const initialState = {
  generalInfo: [
    {
      challanDate: Date(),
      custName: "",
    },
  ],
};

export const generalInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE":
      return {
        ...state,
        generalInfo: action.payload,
      };
    default:
      return { ...state };
  }
};
